import { useEffect, useState } from "react";
import api from "../../lib/api";

export default function AdminCustomers() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/customers").then((r) => setItems(r.data)); }, []);

  return (
    <div>
      <h1 className="font-display text-3xl mb-6">Customers</h1>
      <div className="gf-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F8F4E9] text-xs uppercase tracking-wider text-[#6B5F58]">
            <tr>
              <th className="text-left px-4 py-3">Name</th>
              <th className="text-left px-4 py-3">Phone</th>
              <th className="text-left px-4 py-3">Email</th>
              <th className="text-left px-4 py-3">KYC</th>
              <th className="text-left px-4 py-3">Joined</th>
            </tr>
          </thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} className="border-t border-[#E8E0D2]">
                <td className="px-4 py-3 font-medium">{c.full_name || "—"}</td>
                <td className="px-4 py-3">{c.phone}</td>
                <td className="px-4 py-3">{c.email || "—"}</td>
                <td className="px-4 py-3">
                  <span className={`px-2 py-0.5 rounded-full text-xs ${
                    c.kyc_status === "approved" ? "bg-[#FCEDED] text-[#D71921]"
                    : c.kyc_status === "rejected" ? "bg-red-100 text-red-800"
                    : c.kyc_status === "pending" ? "bg-amber-100 text-amber-800"
                    : "bg-stone-100 text-stone-700"}`}>{c.kyc_status}</span>
                </td>
                <td className="px-4 py-3 text-xs">{(c.created_at || "").slice(0,10)}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="px-4 py-12 text-center text-[#6B5F58]">No customers yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
